import React, { forwardRef } from 'react';
import CalendarDropdown from './CalendarDropdown';

interface DateDropdownProps {
  selectedDate: Date | null;
  onDateChange: (date: Date | null) => void;
  minDate: Date;
  placeholderText: string;
  required: boolean;
}

interface CustomInputProps {
  value?: string;
  onClick?: () => void;
  isCalendarOpen?: boolean;
}

const CustomDateInput = forwardRef<HTMLButtonElement, CustomInputProps>(({ value, onClick, isCalendarOpen }, ref) => (
  <button
    type="button"
    className="form-control custom-date-dropdown-toggle mt-2"
    onClick={onClick}
    ref={ref}
  >
    {value || 'Select a date'}
    <span className={`arrow-icon ${isCalendarOpen ? 'open' : ''}`}>&#9660;</span>
  </button>
));

const DateDropdown: React.FC<DateDropdownProps> = ({
  selectedDate,
  onDateChange,
  minDate,
  placeholderText,
  required,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = React.useState(false);

  return (
    <div className="custom-date-dropdown-container">
      <CustomDateInput
        value={selectedDate ? selectedDate.toLocaleDateString() : ''}
        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
        isCalendarOpen={isCalendarOpen}
      />
      <CalendarDropdown
        selectedDate={selectedDate}
        onDateChange={onDateChange}
        minDate={minDate}
        isOpen={isCalendarOpen}
        setIsOpen={setIsCalendarOpen}
      />
    </div>
  );
};

export default DateDropdown;